import React from 'react';
import Menu from '../components/Menu';
import MapImage from '../images/map_ringsted.jpg';
import './StaticMap.css';

export const StaticMap = () => {
    return(
        <div className="App">
            <Menu/>
            <div className='static-map'>
                <img src={MapImage} alt=""/>
            </div>
        </div>
    )
};